import { render } from "./UserPriorities.vue?vue&type=template&id=5915876a&scoped=true"
import script from "./UserPriorities.vue?vue&type=script&lang=js"
export * from "./UserPriorities.vue?vue&type=script&lang=js"

import "./UserPriorities.vue?vue&type=style&index=0&id=5915876a&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5915876a"]])

export default __exports__